import { Component, Input } from '@angular/core';
import { AdminActionsDirective } from '@app/main/admin/directives/admin-actions.directive';
import { AdminService } from '../../../../admin.service';
import { IGlossary } from '@shared/interfaces';
import { DialogService } from '@shared/services';
import { ModuleService } from '@shared/services/module.service';

@Component({
    selector: 'app-admin-glossary-item',
    templateUrl: './admin-glossary-item.component.html',
    styleUrls: ['./admin-glossary-item.component.scss'],
    standalone: false
})
export class AdminGlossaryItemComponent extends AdminActionsDirective {
    @Input() index: number;
    @Input() item: IGlossary;

    constructor(adminService: AdminService, dialogService: DialogService, moduleService: ModuleService) {
        super(adminService, dialogService, moduleService);
    }
}
